import React from 'react';
import styles from './IconButton.module.css';

export type IconButtonSize = 'sm' | 'md' | 'lg';
export type IconButtonVariant = 'default' | 'ghost' | 'primary';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  size?: IconButtonSize;
  variant?: IconButtonVariant;
  tooltip?: string;
  isActive?: boolean;
}

export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  size = 'md',
  variant = 'default',
  tooltip,
  isActive = false,
  className = '',
  ...props
}) => {
  const buttonClasses = [
    styles.iconButton,
    styles[size],
    styles[variant],
    isActive ? styles.active : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={buttonClasses}
      title={tooltip}
      aria-label={tooltip}
      {...props}
    >
      {icon}
    </button>
  );
};

export default IconButton;
